<template lang="pug">
//- FORMULARIO
div
  edit-form(
    v-for="(edit,index) in forms"
    v-bind="$props"
    :key="`form-${index}`"
    :edit="edit"
    :entity="entity"
    @refresh="args => $emit('refresh', args)"
  )
</template>

<script>
import EditForm from './EditForm'

export default {
  components: {
    EditForm,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,
    busy: Boolean,
  },

  computed: {
    title: vm => vm.entity?.title || vm.entity?.name || vm.entity?.eref,
    description: vm => vm.entity?.description,
    forms: vm => vm.entity.forms || [],
  },
}
</script>
